import * as React from "react"
const BlackFire = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#202327"
      d="M14.195 1.737a1 1 0 0 1 .885.073c5.687 3.421 10.942 9.265 12.663 14.898.867 2.84.864 5.732-.582 8.212-1.445 2.479-4.213 4.345-8.447 5.384a1 1 0 0 1-.989-1.632c1.732-1.965 3.262-4.262 3.485-6.68.17-1.842-.407-3.929-2.624-6.148.016 2.362-.894 4.33-1.81 5.454a1 1 0 0 1-1.756-.435c-.367-1.832-1.407-2.64-2.516-3.207-.075 1.56-.756 2.684-1.251 3.502-.14.23-.265.437-.358.622-1.474 2.949.31 5.09 1.546 6.57l.291.351a1 1 0 0 1-1.124 1.57c-3.818-1.42-6.52-4.08-7.52-7.326C3.084 19.679 3.855 16 6.629 12.69c.889-1.062 1.666-1.942 2.35-2.717 2.409-2.728 3.667-4.153 4.623-7.576a1 1 0 0 1 .594-.66Z"
    />
  </svg>
)
export default BlackFire
